import { SharedLocationStore } from './shared-location/shared-location-store';
import ScheduleStore from './schedule/schedule-store';
import DriverTrackingStore from './driver-tracking/driver-tracking-store';
import CustomerTrackingStore from './customer-tracking/customer-tracking-store';
import { getEnv } from 'mobx-easy';
import { observable, action, makeObservable } from 'mobx';
import { CustomerExperienceStore } from './customer-experience/customer-experience-store';
import { ApiVersion } from '@bringg/types';
import { RootEnv } from '../helpers/create-store';
import AriaStore from './aria/aria-store';

class RootStore {
	sharedLocationStore: SharedLocationStore;
	customerExperienceStore: CustomerExperienceStore;
	scheduleStore: ScheduleStore;
	driverTrackingStore: DriverTrackingStore;
	customerTrackingStore: CustomerTrackingStore;
	ariaStore: AriaStore;

	apiVersion: ApiVersion = null;

	isError: boolean = false;

	constructor() {
		makeObservable(this, {
			apiVersion: observable,
			isError: observable,
			setApiVersion: action,
			setIsError: action
		});
	}

	setApiVersion(apiVersion: ApiVersion) {
		this.apiVersion = apiVersion;
	}

	setIsError(isError: boolean) {
		this.isError = isError;
	}

	init() {
		this.sharedLocationStore = new SharedLocationStore();
		this.customerExperienceStore = new CustomerExperienceStore();
		this.scheduleStore = new ScheduleStore();
		this.driverTrackingStore = new DriverTrackingStore();
		this.customerTrackingStore = new CustomerTrackingStore();
		this.ariaStore = new AriaStore();
	}

	initCustomerExperience = async (sharedLocationUuid: string) => {
		const { customerExperienceService } = getEnv<RootEnv>();
		const apiVersion = (await customerExperienceService.getApiVersion(sharedLocationUuid))?.api_version;

		this.setApiVersion(apiVersion);

		switch (apiVersion) {
			case ApiVersion.V1:
				return this.sharedLocationStore.initialize(sharedLocationUuid);
			case ApiVersion.V2:
				return this.customerExperienceStore.initialize(sharedLocationUuid);
			default:
				throw new Error('Api version not supported');
		}
	};
}

export default RootStore;
